/* eslint-disable max-lines */
/* eslint-disable complexity */
import React, { useState, useEffect } from 'react'
import GetmoviesAppInfoData from '../../Services/Queries/GetmoviesAppInfoConfigService'
import CreateDynamicList from '../../Services/Mutations/CreateDynamicList'
import GetDynamicListBasedOnId from '../../Services/Queries/GetDynamicListBasedOnId'
import UpdateDynamicList from '../../Services/Mutations/UpdateDynamicList'
import { v4 as uuidv4 } from 'uuid'
import MovieImagePresignedUrl from '../../Services/Queries/Movieimagepresignedurl'
import axios from 'axios'
import { Auth } from 'aws-amplify'
import { toast } from 'react-toastify'
import TagPersonsAtHeaderLevelToDynamicListService from '../../Services/Mutations/TagPersonsAtHeaderLevelToDynamicListService'
import UntagPersonsAtHeaderLevelFromDynamicListService from '../../Services/Mutations/UntagPersonsAtHeaderLevelFromDynamicListService'
import { ToastStyle } from '../Data/MovieStaticData'
import CreateAndEditDynamiclistUi from './CreateAndEditDynamiclistUi'
import { dynamiclistobj } from '../Data/StaticPersonandMoviedata'
import ListHeaderLevelTaggedPersonsInDynamicList from '../../Services/Queries/ListHeaderLevelTaggedPersonsInDynamicList'
import AwsConfig from '../../Config/AwsConfig'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../Constants/Permissions'

export default function CreateOrEditDynamicList() {
  const [ImageChanged, setImageChanged] = useState(false)
  const [UnTagHeaderLevelPersons, setUnTagHeaderLevelPersons] = useState([])
  const [configData, setConfigData] = useState({})
  const [mode, setMode] = useState('create')
  const [horizontalImagePresent, setHorizontalImage] = useState(false)
  const [DynamicId, setDynamicId] = useState('')
  const [listData, setListData] = useState(dynamiclistobj)
  const [Data, setData] = useState()
  const [headerLevelPersons, setheaderLevelPersons] = useState([])
  const [dynamicListInfo, setDynamicListInfo] = useState({})
  const [loadSpinner, setLoadSpinner] = useState(false)
  const [loadPopup, setLoadPopup] = useState(false)
  const [EDitApproveOptionBoolean, setEDitApproveOptionBoolean] = useState(false)

  const navigate = Id => {
    if (mode === 'create') {
      // setLoadPopup(true)
      setTimeout(() => {
        window.open('createDynamicList?' + encodeURI(Id))
      }, 4000)
    } else if (mode === 'edit') {
      if (
        EDitApproveOptionBoolean &&
        listData.dynamicListStatus &&
        listData.dynamicListStatus === 'draft'
      ) {
        setLoadPopup(true)
      } else {
        setTimeout(() => {
          window.location.reload()
        }, 8000)
      }
    }
  }

  const uploadImage = async () => {
    const randomId = await uuidv4()
    const key = AwsConfig.dynamicListPathUrl + randomId + '.jpeg'
    const params = {
      key,
      mimeType: 'image/jpeg',
    }
    const preSignedURLObject = await MovieImagePresignedUrl(params)
    const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
    const signedURL = signedURLObject.data.url
    const formData = new FormData()
    Object.keys(signedURLObject.data.fields).forEach(key => {
      formData.append(key, signedURLObject.data.fields[key])
    })
    // Actual file has to be appended last.
    formData.append('file', listData.dynamicListImage)

    await axios({
      method: 'post',
      url: signedURL,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return key
  }

  const handleCreateOrUpdateDynamicList = async () => {
    setLoadSpinner(true)
    const removeDuplicates = inputText => {
      // const cdnurl = AwsConfig.movieCdnUrl

      const words = inputText.split(AwsConfig.movieCdnUrl)

      const uniqueWords = [...new Set(words)]

      const result = uniqueWords.join('')

      return result
    }

    //   listData.dynamicListImage,
    //   'listData.dynamicListImagelistData.dynamicListImagelistData.dynamicListImage55555555555',
    // )
    const uploadedImage =
      listData.dynamicListImage &&
      typeof listData.dynamicListImage !== 'object' &&
      listData.dynamicListImage.includes('public')
        ? listData.dynamicListImage
        : await uploadImage()
    let input = {}
    let loggedInUserHandle = ''
    const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
    if (loggedInUserEmail) {
      const emailParams = loggedInUserEmail.split('@')
      loggedInUserHandle = '@' + emailParams[0]
    }

    if (listData.dynamicListType === 'trendingLists') {
      input = {
        moderatorID: mode === 'edit' ? listData.createdByID : Auth.user.username,
        moderatorHandle: mode === 'edit' ? listData.createdByHandle : loggedInUserHandle,
        title_En: listData.title_En,
        title_Te: listData.title_Te,
        sortBy: listData.sortBy,

        description_En: listData.description_En,
        description_Te: listData.description_Te,
        dynamicListImage: ImageChanged
          ? removeDuplicates(uploadedImage)
          : removeDuplicates(listData.dynamicListImage),
        dynamicListType: mode === 'edit' ? listData.dynamicListType : 'trendingLists',
        popularListType: listData.popularListType,
        popularListCategory: listData.popularListCategory,
        limit: listData.limit,
      }
      if (input.popularListType === 'movies') {
        input.movieID = listData.movieID
      }

      if (input.popularListType === 'person') {
        input.personID = listData.personID
      }

      if (input.popularListCategory === 'views') {
        input.viewsType = listData.viewsType
        if (input.likesType) {
          delete input.likesType
        }
      }

      if (input.popularListCategory === 'likes') {
        input.likesType = listData.likesType
        if (input.viewsType) {
          delete input.viewsType
        }
      }
    }

    if (listData.dynamicListType === 'movies') {
      input = {
        PK: listData.PK,
        SK: listData.SK,
        moderatorID: mode === 'edit' ? listData.createdByID : Auth.user.username,
        moderatorHandle: mode === 'edit' ? listData.createdByHandle : loggedInUserHandle,
        title_En: listData.title_En,
        title_Te: listData.title_Te,
        description_En: listData.description_En,
        description_Te: listData.description_Te,
        dynamicListImage: ImageChanged
          ? removeDuplicates(uploadedImage)
          : removeDuplicates(listData.dynamicListImage),
        dynamicListType: mode === 'edit' ? listData.dynamicListType : 'movies',
        popularListType: listData.popularListType,
        contentType: mode === 'edit' ? listData.contentType : 'movies',
        sortBy: listData.sortBy,
        ageRestriction: listData.ageRestriction,
        directedBy_En: listData.directedBy_En,
        cinematography_En: listData.cinematography_En,
        editedBy_En: listData.editedBy_En,
        musicBy_En: listData.musicBy_En,
        producedBy_En: listData.producedBy_En,
        writtenBy_En: listData.writtenBy_En,
        dialogueBy_En: listData.dialogueBy_En,
        screenplayBy_En: listData.screenplayBy_En,
        storyBy_En: listData.storyBy_En,
        cast_En: listData.cast_En,
        crewFilterBy: listData.crewFilterBy,
        castFilterBy: listData.castFilterBy,
        fromDate: listData.fromDate,
        toDate: listData.toDate,
        limit: listData.limit,
      }

      if (listData.genre_En) {
        input.genre_En = listData.genre_En
        input.genre_Te = listData.genre_Te
      }

      if (listData.ottPlatform) {
        input.ottPlatform = listData.ottPlatform ? listData.ottPlatform : []
      }
    }

    if (mode === 'edit') {
      input.dynamicListID = listData.dynamicListID
      input.PK = listData.PK
      input.SK = listData.SK
    }

    input.ottPlatform = listData.ottPlatform ? listData.ottPlatform : []

    if (listData.fromRating) {
      input.fromRating = listData.fromRating
    }

    if (listData.toRating) {
      input.toRating = listData.toRating
    }

    if (listData.toRatingV2) {
      input.toRatingV2 = listData.toRatingV2
    }

    if (listData.fromRatingV2) {
      input.fromRatingV2 = listData.fromRatingV2
    }

    // if (listData.limit) {
    //   input.limit = listData.limit
    // }

    const tagPerson = async id => {
      if (UnTagHeaderLevelPersons.length !== 0) {
        const input = {
          dynamicListID: id,
          personIDs: UnTagHeaderLevelPersons,
        }

        await UntagPersonsAtHeaderLevelFromDynamicListService(input)
      }

      if (headerLevelPersons.length !== 0) {
        const responseTag = await TagPersonsAtHeaderLevelToDynamicListService({
          dynamicListID: id,
          addedByID: input.moderatorID,
          addedByHandle: input.moderatorHandle,
          personIDs: headerLevelPersons.map(e => (e.personID ? e.personID : e.PK)),
        })

        if (responseTag.statusCode === 'A050') {
          toast.success(responseTag.statusMessage, ToastStyle)
        }
      }
    }

    if (mode === 'edit') {
      try {
        const { dynamicListID } = input
        const dataArray = input
        await Object.keys(dataArray).forEach(key => {
          if (
            dataArray[key] === null ||
            dataArray[key] === undefined ||
            dataArray[key].length === 0 ||
            dataArray[key] === ''
          ) {
            delete dataArray[key]
          }
        })
        delete dataArray.dynamicListID

        const updateDynamicListResponse = await UpdateDynamicList(dataArray)

        if (updateDynamicListResponse.statusCode === 'A044') {
          tagPerson(dynamicListID)
          toast.success('Dynamic List Updated Successfully')
          // setTimeout(() => {
          //   window.location.reload()
          // }, 5000)
          navigate()
        }
      } catch (error) {
        console.warn(error)
        toast.error('Something Went Wrong')
      }
    } else {
      try {
        Object.keys(input).forEach(key => {
          if (
            (input[key] && input[key] === null) ||
            (input[key] && input[key].length === 0) ||
            (input[key] && input[key] === undefined)
          ) {
            delete input[key]
          }
        })

        if (input.fromDate === '') {
          delete input.fromDate
        }

        if (input.toDate === '') {
          delete input.toDate
        }

        const createDynamicListResponse = await CreateDynamicList(input)

        if (createDynamicListResponse.statusCode === 'A044') {
          setDynamicId(createDynamicListResponse ? createDynamicListResponse.SK : '')
          toast.success('Dynamic List Created Successfully')
          tagPerson(createDynamicListResponse.SK)
          const Id = createDynamicListResponse.SK.replace('dynamicList#', '')
          navigate(Id)
          // setTimeout(() => {
          //   window.open('createDynamicList?' + encodeURI(Id))
          // }, 4000)
        }
      } catch (error) {
        console.warn(error)
        toast.error('Something Went Wrong')
      }
    }

    setLoadSpinner(false)
  }

  const getConfigData = async () => {
    dynamicListInfo.popularListType = 'movies'
    listData.popularListType = 'movies'
    dynamicListInfo.dynamicListType = 'movies'
    const permissionInput = {
      mobileNumber: Auth.user.attributes.phone_number,
    }
    const userPermissions = await GetUserPermissions(permissionInput)
    const permissions = []
    const permissionsArr = []
    if (userPermissions && userPermissions.userRolesAndPermissions) {
      userPermissions.userRolesAndPermissions.map(item => {
        permissions.push(...item.permissions)
        return item
      })
      permissions.map(permission => {
        permissionsArr.push(permission.name)
        return permission
      })
    }

    const EDitApproveOption = permissionsArr.includes(DefinedPermissions.DisplayApproveMovieOption)

    setEDitApproveOptionBoolean(EDitApproveOption)
    const query = window.location.href.split('?')[1]
    if (query) {
      const dynamicListID = 'dynamicList#' + query
      setMode('edit')

      const listDataFromResponse = await GetDynamicListBasedOnId({
        dynamicListID,
      })

      const listData = { ...listDataFromResponse }

      Object.keys(listData).forEach(key => {
        if (
          listData[key] === null ||
          listData[key] === '' ||
          listData[key].length === 0 ||
          listData[key] === undefined
        ) {
          delete listData[key]
        }
      })

      listData.selectedImage = listData.dynamicListImage

      setDynamicListInfo(listData)
      if (listData) {
        setListData(listData)
        setData(listData)
      }

      const input = { dynamicListID, limit: 100 }
      const listHeaderLevelData = await ListHeaderLevelTaggedPersonsInDynamicList(input)

      setheaderLevelPersons(
        listHeaderLevelData && listHeaderLevelData.items ? listHeaderLevelData.items : [],
      )
    }

    const response = await GetmoviesAppInfoData()
    setConfigData(response && response.getMoviesAppInfoConfig)
    setLoadSpinner(false)
  }

  useEffect(() => {
    setLoadSpinner(true)
    const handleVisibilityChange = () => {
      if (!document.hidden && !Data) {
        getConfigData() // Fetch data when the tab becomes visible and data is not available
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Fetch data when the component is mounted if dynamicListInfo is not available
    if (!Data) {
      getConfigData()
    }

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [Data])

  const checkDisabled =
    listData &&
    listData.title_En &&
    listData.title_En.length > 0 &&
    listData &&
    listData.title_Te &&
    listData.title_Te.length > 0 &&
    listData &&
    listData.description_En &&
    listData.description_En.length > 0 &&
    listData &&
    listData.description_Te &&
    listData.description_Te.length > 0 &&
    horizontalImagePresent

  return (
    <CreateAndEditDynamiclistUi
      setImageChanged={setImageChanged}
      setUnTagHeaderLevelPersons={setUnTagHeaderLevelPersons}
      setDynamicListInfo={setDynamicListInfo}
      dynamicListInfo={dynamicListInfo}
      headerLevelPersons={headerLevelPersons}
      setheaderLevelPersons={setheaderLevelPersons}
      mode={mode}
      DynamicId={DynamicId}
      listData={listData}
      horizontalImagePresent={horizontalImagePresent}
      setHorizontalImage={setHorizontalImage}
      configData={configData}
      checkDisabled={checkDisabled}
      handleCreateOrUpdateDynamicList={handleCreateOrUpdateDynamicList}
      setListData={setListData}
      loadSpinner={loadSpinner}
      setLoadSpinner={setLoadSpinner}
      loadPopup={loadPopup}
      setLoadPopup={setLoadPopup}
    />
  )
}
